'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('react-utils/utils');

var _constants = require('event-tracking-tools/redux/constants');

var _Immutable = require('Immutable');

var _typeHelpers = require('event-tracking-tools/utils/typeHelpers');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createLogAction(record) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var isMap = _Immutable.Map.isMap(record);
  var isRecord = record instanceof _Immutable.Record;
  (0, _utils.invariant)(isRecord || (0, _typeHelpers.isObject)(record) && !isRecord && !isMap, '[createLogAction]: first parameter "record" must be an Immutable Record of the logger\'s expected type or a plain JS object.');
  return {
    type: _constants.TRACK_EVENT,
    meta: _defineProperty({}, _constants.TRACK_EVENT, {
      record: record,
      props: props
    })
  };
}

exports.default = createLogAction;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/redux/createLogAction.js
// module id = 435
// module chunks = 0